import script from "./InstituteSecurityForm.vue?vue&type=script&setup=true&lang=js"
export * from "./InstituteSecurityForm.vue?vue&type=script&setup=true&lang=js"

import "./InstituteSecurityForm.vue?vue&type=style&index=0&id=30886230&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30886230"]])

export default __exports__